import { Container, Stack, Typography } from '@mui/material';
import React from 'react';
import { toast } from 'react-hot-toast';
import { useParams } from 'react-router-dom';
//
import * as shortlinkService from '../services/shortlink';

const PDFShorlinkListener = () => {
  const { id } = useParams();

  const getShortLink = async () => {
    try {
      const result = await shortlinkService.getShortlink(id);
      const { link } = result.data;

      if (link) window.location.replace(link);
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getShortLink();
  }, [id]);
  return (
    <Container maxWidth="md">
      <Stack direction="column" spacing={1} m={4}>
        <Typography variant="h6">Please wait, redirecting ...</Typography>
        <Typography variant="body2" style={{ fontStyle: 'italic' }}>
          Please refresh this page if nothing happened
        </Typography>
      </Stack>
    </Container>
  );
};

export default PDFShorlinkListener;
